import { StoreItem, StoreItemOption } from "./storeItem";

export class CartItem {
    storeItem: StoreItem;
    selectedOption: StoreItemOption;
    quantity: number;
    validCartItem: boolean;
    errorMessage: string;
}